// // import { Link, useLocation } from 'react-router-dom';

// // const Layout = ({ children }) => {
// //   const location = useLocation();

// //   const isActive = (path) =>
// //     location.pathname === path ? 'nav-link active' : 'nav-link';

// //   return (
// //     <div className="app-container">
// //       <aside className="sidebar">
// //         <div className="logo">Payslip Admin</div>
// //         <nav>
// //           <Link className={isActive('/dashboard')} to="/dashboard">
// //             Dashboard
// //           </Link>
// //           <Link className={isActive('/employees')} to="/employees">
// //             Employees
// //           </Link>
// //           <Link className={isActive('/payroll/upload')} to="/payroll/upload">
// //             Payroll Upload
// //           </Link>
// //           <Link className={isActive('/payslips')} to="/payslips">
// //             Payslips
// //           </Link>
// //         </nav>
// //       </aside>
// //       <main className="main-content">
// //         {children}
// //       </main>
// //     </div>
// //   );
// // };

// // export default Layout;





// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { logout } from "../auth";

// const Layout = ({ children }) => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const isActive = (path) => {
//     // active when path matches exactly or is a prefix (e.g. /employees/123)
//     if (path === "/") return location.pathname === "/";
//     return location.pathname === path || location.pathname.startsWith(path + "/");
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/login", { replace: true });
//   };

//   return (
//     <div className="app-shell">
//       {/* Sidebar */}
//       <aside className="sidebar">
//         <div className="sidebar-brand">
//           <div className="sidebar-logo-circle">QS</div>
//           <div className="sidebar-brand-text">
//             <span className="sidebar-brand-title">Payslip Admin</span>
//             <span className="sidebar-brand-subtitle">
//               Quantumnique Solutions
//             </span>
//           </div>
//         </div>

//         <nav className="sidebar-nav">
//           <Link
//             className={`sidebar-link ${isActive("/dashboard") ? "active" : ""}`}
//             to="/dashboard"
//           >
//             <span className="sidebar-link-icon">📊</span>
//             <span>Dashboard</span>
//           </Link>

//           <Link
//             className={`sidebar-link ${isActive("/employees") ? "active" : ""}`}
//             to="/employees"
//           >
//             <span className="sidebar-link-icon">👥</span>
//             <span>Employees</span>
//           </Link>

//           <Link
//             className={`sidebar-link ${
//               isActive("/payroll/upload") ? "active" : ""
//             }`}
//             to="/payroll/upload"
//           >
//             <span className="sidebar-link-icon">📥</span>
//             <span>Payroll Upload</span>
//           </Link>

//           <Link
//             className={`sidebar-link ${isActive("/payslips") ? "active" : ""}`}
//             to="/payslips"
//           >
//             <span className="sidebar-link-icon">🧾</span>
//             <span>Payslips</span>
//           </Link>
//           <Link className={isActive('/daily-sheet-admin')} to="/daily-sheet-admin">
//             Daily Sheet (Team)
//           </Link>

//           <button className="sidebar-logout-btn" onClick={handleLogout}>
//             Log out
//           </button>
//         </nav>

//         <div className="sidebar-footer">
//           <span className="sidebar-footer-label">Logged in as</span>
//           <span className="sidebar-footer-user">Admin</span>
//         </div>
//       </aside>

//       {/* Main content */}
//       <main className="app-main">
//         <div className="app-main-inner">{children}</div>
//       </main>
//     </div>
//   );
// };

// export default Layout;








import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout, getAuthSession } from "../auth";
import logoImg from "../logo.png";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const session = getAuthSession();
  const role = session?.role || "admin";
  const displayName =
    role === "manager"
      ? session?.employee?.name || "Manager"
      : "Admin";

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <div className="sidebar-logo-wrap">
            <img src={logoImg} alt="Company logo" className="sidebar-logo-img" />
          </div>
          <div className="sidebar-brand-text">
            <span className="sidebar-brand-title">QDesk Admin</span>
            <span className="sidebar-brand-subtitle">
              Quantumnique Solutions
            </span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {role === "admin" && (
            <>
              <Link
                className={`sidebar-link ${isActive("/dashboard") ? "active" : ""}`}
                to="/dashboard"
              >
                <span className="sidebar-link-icon">📊</span>
                <span>Dashboard</span>
              </Link>

          <Link
            className={`sidebar-link ${isActive("/employees") ? "active" : ""}`}
            to="/employees"
          >
            <span className="sidebar-link-icon">👥</span>
            <span>Employees</span>
          </Link>

          <Link
            className={`sidebar-link ${isActive("/payroll/upload") ? "active" : ""}`}
            to="/payroll/upload"
          >
            <span className="sidebar-link-icon">📥</span>
            <span>Payroll Upload</span>
          </Link>

          <Link
            className={`sidebar-link ${isActive("/payslips") ? "active" : ""}`}
            to="/payslips"
          >
            <span className="sidebar-link-icon">🧾</span>
            <span>Payslips</span>
          </Link>

          <Link
            className={`sidebar-link ${isActive("/newsletters") ? "active" : ""}`}
            to="/newsletters"
          >
            <span className="sidebar-link-icon">📰</span>
            <span>Newsletters</span>
          </Link>

              <Link
                className={`sidebar-link ${isActive("/holidays") ? "active" : ""}`}
                to="/holidays"
              >
                <span className="sidebar-link-icon">🎉</span>
                <span>Holidays</span>
              </Link>
            </>
          )}

          <Link
            className={`sidebar-link ${isActive("/daily-sheet-admin") ? "active" : ""}`}
            to="/daily-sheet-admin"
          >
            <span className="sidebar-link-icon">📅</span>
            <span>Daily Sheet (Team)</span>
          </Link>

          <button className="sidebar-logout-btn" onClick={handleLogout}>
            Log out
          </button>
        </nav>

        <div className="sidebar-footer">
          <span className="sidebar-footer-label">Logged in as</span>
          <span className="sidebar-footer-user">
            {displayName} ({role})
          </span>
        </div>
      </aside>

      <main className="app-main">
        <div className="app-main-inner">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
